// extracted by mini-css-extract-plugin
export default {"cls1":"AutoCompleteResultRow-cls1___eda3647c7cb832c99cb","cls2":"AutoCompleteResultRow-cls2___a1fc80a9f7e3c11323b AutoCompleteResultRow-cls1___eda3647c7cb832c99cb"};